import type Phaser from "phaser";

/** 시너지 전용 벡터 아이콘 — 에셋 추가 없이 세 파이프 효과가 연결되는 네트워크를 그린다. */
export function drawSynergyIcon(
  g: Phaser.GameObjects.Graphics,
  size: number,
  color: number,
  bgColor: number,
  lineAlpha = 0.92,
): Phaser.GameObjects.Graphics {
  const r = size / 2;
  const nodeR = Math.max(2.4, size * 0.12);
  const topY = -size * 0.28;
  const leftX = -size * 0.26;
  const rightX = size * 0.26;
  const bottomY = size * 0.25;

  g.clear();
  g.fillStyle(bgColor, 0.72).fillCircle(0, 0, r);
  g.lineStyle(Math.max(1.5, size * 0.09), color, lineAlpha);
  g.beginPath();
  g.moveTo(0, topY);
  g.lineTo(leftX, bottomY);
  g.lineTo(rightX, bottomY);
  g.lineTo(0, topY);
  g.strokePath();
  g.fillStyle(color, 1);
  g.fillCircle(0, topY, nodeR);
  g.fillCircle(leftX, bottomY, nodeR);
  g.fillCircle(rightX, bottomY, nodeR);
  g.fillStyle(0xffffff, 0.74);
  g.fillCircle(0, topY, Math.max(1.1, nodeR * 0.42));
  return g;
}
